export const cart: object = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Proceed to Checkout',
    cartName: 'Cart #{{code}}',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
  },
  cartItems: {
    id: 'ID',
    description: 'Beschreibung',
    item: 'Artikel',
    itemPrice: 'Preis des Artikels',
    quantity: 'Menge',
    quantityTitle: 'Die Menge gibt die Gesamtzahl dieses Artikels in Ihrem Warenkorb an.',
    itemsThatNeedToBeCheckedOutSeparately: 'Sie haben möglicherweise Artikel, die separat ausgecheckt werden müssen. Bitte sehen Sie sich zuerst die unten stehenden Lösungen an. Sie können besuchen',
    toStartWithTheOtherItems: 'um mit den anderen Gegenständen zu beginnen.',
    total: 'Total',
    cartTotal: 'Cart total ({{count}} item)',
    cartTotal_plural: 'Cart total ({{count}} items)',
    additionalLicenses: 'Zusätzliche Lizenzen',
    priceSubtitle: 'Zwischensumme',
    deployment: 'Bereitstellung',
    duration: 'Dauer',
    removeProductSuccess: 'wurde aus Ihrem Warenkorb entfernt',
    priceTooltip: {
      header: 'Pricing Summary',
      per: {
        header: 'Price per License',
        licenseMaterial: 'License Material',
        quantity: 'Quantity',
        pricePer: 'Price per License/ Month',
      },
      breakdown: {
        header: 'Order Summary',
        configuration: 'Configuration',
        duration: 'Duration',
        cost: 'Cost',
      },
      subtotal: {
        title: 'Subtotal',
        excludingTax: 'Excluding tax',
        existingPricing: 'Existing contract pricing, billing and terms apply',
        taxCalculated: 'Tax Calculated at Checkout',
      }
    },
    initialPurchase: 'Initial purchase',
    discounts: {
      discount: '- {{formattedAbsoluteValue}} discount',
      youSaved: 'You saved {{formattedAbsoluteValue}}'
    }
  },
  orderCost: {
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal after discounts:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'You saved:',
    salesTax: 'Sales Tax:',
    grossTax: 'The order total does not include tax of',
    total: 'Total:',
    recurringTotal: 'Recurring Annual Total'
  },
  voucher: {
    coupon: 'Promotion code',
    coupon_plural: 'Coupon codes',
    apply: 'Apply',
    placeholder: 'Enter code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    anchorLabel: 'Enter or remove your coupon code',
    vouchersApplied: 'Applied coupons',
    errors: {
      invalidCouponCode: 'Ihr eingegebener Code ist ungültig oder Ihr Warenkorb ist nicht für die Aktion qualifiziert.',
      alreadyExistingCoupon: 'Ihr eingegebener Code ist bereits angewendet.',
      cartFailedRequirements: 'Ihr Warenkorb entspricht nicht den Aktionsbedingungen.',
      amountExceeded: 'Der Zugang ist vorübergehend gesperrt, da die maximale Versuchsanzahl überschritten wurde. Bitte versuchen Sie es später noch einmal.',
      voucherNoLongerValid: 'Ihr angewendeter Code "{{voucherCode}}" ist nicht mehr gültig.',
      promoNoLongerValid: 'Ihre beantragte Aktion ist nicht mehr gültig.'
    }
  },
  cart: {
    ariaLabel: 'Cart',
    checkOut: 'Check Out',
    paymentInfo: 'Bestellnummern, Zahlungen und Kontakte können während der Kaufabwicklung verwaltet werden',
    account: 'Konto',
    buyerDetails: 'Käufer Details',
    personalDetails: 'Persönliche Daten',
    technicalContact: 'Technischer Kontakt',
    companyDetails: 'Details zum Unternehmen',
    primaryAccessLocation: 'Ort des primären Zugriffs',
    billing: 'Abrechnung',
    paymentMethod: 'Zahlungsmethode',
    billTo: 'Rechnung an',
    taxExemptionDoc: 'Steuerbefreiungsdokument',
    billingAddress: 'Rechnungsadresse',
  },
};
